import React, { useState } from "react";
import axios from "axios";
import "../style2.css";

const AddProjectModal: React.FC<{ handleAdd: () => void }> = ({
  handleAdd,
}) => {
  const [newUrl, setNewUrl] = useState("");
  const [projectName, setProjectName] = useState("");
  const [isUrlValid, setIsUrlValid] = useState(false);

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value;
    const urlRegex =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const isValid = urlRegex.test(url);
    setIsUrlValid(isValid);
    setNewUrl(url);
  };

  const handleProjectNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProjectName(e.target.value);
  };

  const handleAddProject = async () => {
    try {
      if (!isUrlValid) {
        alert("Veuillez entrer une URL valide.");
        return;
      }

      if (!projectName) {
        alert("Veuillez entrer un nom de projet.");
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_SERVER_API}/api/v1/projects/nouveau`,
        {
          Nom: projectName,
          URL: newUrl,
        }
      );

      handleAdd();
    } catch (error) {
      console.error("Error adding project:", error);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex={-1}
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered custom-modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Ajouter projet</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleAdd}
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control shorter-input"
                  placeholder="Nom du projet"
                  onChange={handleProjectNameChange}
                />
              </div>
              <div className="form-group mt-2">
                <input
                  type="text"
                  className="form-control shorter-input"
                  placeholder="Entrer URL"
                  onChange={handleUrlChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-ok"
                onClick={handleAddProject}
                disabled={!isUrlValid || !projectName}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop-full"></div>
    </>
  );
};

export default AddProjectModal;
